/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `Diese Seite konnte nicht geladen werden`
};

const en_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `This page couldn’t be loaded`
};

const es_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `La página no se pudo cargar`
};

const fr_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `Cette page n’a pas pu être chargée`
};

const it_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `Impossibile caricare questa pagina`
};

const nl_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `Deze pagina kon niet worden geladen`
};

const pt_error__500__title = /** @type {(inputs: {}) => string} */ () => {
	return `Não foi possível carregar esta página`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__500__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__500__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__500__title", locale)
	if (locale === "de") return de_error__500__title(inputs)
	if (locale === "en") return en_error__500__title(inputs)
	if (locale === "es") return es_error__500__title(inputs)
	if (locale === "fr") return fr_error__500__title(inputs)
	if (locale === "it") return it_error__500__title(inputs)
	if (locale === "nl") return nl_error__500__title(inputs)
	return pt_error__500__title(inputs)
};